import React, { useState, useEffect } from 'react';
import { Button, Tooltip } from 'antd';

import { useParams } from 'react-router-dom';
import { errorCatch, GET, JSXMap, useAuth, useTranslateContext } from 'fennec-ui';
import { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { PrinterOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useSearchParams } from 'react-router-dom';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const toPrice = (value) => {
	if (!value) {
		return ""
	}
	return Math.abs(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })
}

export default function TotalPaymentTable(props) {
	const { auth } = props;
	const { eventid } = useParams();
	const { usertype } = useParams();

	const [searchParams, setSearchParams] = useSearchParams();

	const t = useTranslateContext();
	const [loading, setLoading] = useState(false);

	const [data, setData] = useState()

	useEffect(() => {
		setLoading(true);

		let showdisplay = searchParams.get("showdisplay") || false
		let showempty = searchParams.get("showempty") || false
		let showpromo = searchParams.get("showpromo") || false
		let showsum = searchParams.get("showsum") || false
		let showemail = searchParams.get("showemail") || false
		let showcomment = searchParams.get("showcomment") || false

		GET(auth, `/api/report/total-payment-table/${eventid}/${usertype}?showdisplay=${showdisplay}&showempty=${showempty}&showpromo=${showpromo}&showsum=${showsum}&showemail=${showemail}&showcomment=${showcomment}`, ({ data }) => {
			setData(data)
			setLoading(false);
		}, (err) => errorCatch(err, () => setLoading(false)));

	}, [auth]);

	const ref = useRef(null)
	const isUsed = (uchastnik, usluga) => {
		//Парная услуга партнер
		if (usluga?.tipTDID == 2 && uchastnik?.ID && uchastnik.ID == usluga?.partnerID) {
			return usluga?.usedPartner
		}

		return usluga?.used
	}
	return (
		<div>
			<ReactToPrint
				trigger={() => {
					// NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
					// to the root node of the returned component as it will be overwritten.
					return <div style={{ display: "flex", justifyContent: "right", padding: "15px 20px" }} >
						<Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }}><PrinterOutlined /> Печать</Button>
					</div>
				}}
				content={() => ref.current}
			/>
			{(data?.meropriyatie) && <div className="report" ref={ref}>
				<article style={{ padding: "0 20px 50px 20px" }}>
					<div style={{ margin: "25px 15px", textAlign: "center" }}>
						<h3>
							{data.meropriyatie.nazvanieMeropriyatiya}, г. {data.meropriyatie.mestoProvedeniya.name}, {dayjs(data.meropriyatie.nachaloSorevnovaniya).format("DD.MM.YYYY")}
						</h3>
					</div>
					<table border="1" cellPadding={8} className="report-table" style={{ color: "black", margin: "25px auto", tableLayout: "fixed" }}>
						<thead style={{ textAlign: "center" }}>
							<tr style={{ backgroundColor: "#ffffc1", overflowWrap: "anywhere" }}>
								<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}>№</td>
								<td style={{ fontWeight: "600", minWidth: "55px" }}>Дата последней покупки</td>

								{(data?.showsum) && <td style={{ fontWeight: "600", minWidth: "55px" }}>Общая сумма покупки</td>}

								{(data?.showpromo && data?.userType != "artist") &&
									<td style={{ fontWeight: "600", minWidth: "55px" }}>Промокоды</td>}

								<td style={{ fontWeight: "600", minWidth: "55px" }}>Покупатели</td>
								<td style={{ fontWeight: "600", minWidth: "55px" }}>Участник</td>

								{(data?.showemail && data?.userType != "artist") &&
									<td style={{ fontWeight: "600", minWidth: "55px" }}>E-mail</td>}
								{(data?.showemail && data?.userType != "artist") &&
									<td style={{ fontWeight: "600", minWidth: "55px" }}>Телефон</td>}
								{(data?.showcomment) && <td style={{ fontWeight: "600", minWidth: "55px" }}>Комментарии</td>}

								{JSXMap(data?.tptYacheikiUslugi, (yacheika, idx) => {
									return (<td key={idx} style={{ fontWeight: "600", minWidth: "55px" }}>{yacheika?.yacheikaUslugi?.nazvanie}</td>)
								})}
							</tr>
							<tr style={{ backgroundColor: "#cccccc", overflowWrap: "anywhere", fontSize: "14px" }}>
								<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>
								<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>

								{(data?.showsum) && <td style={{ fontWeight: "600", minWidth: "55px", textAlign: "right" }}>{toPrice(data?.totalSumm)}</td>}

								{(data?.showpromo && data?.userType != "artist") &&
									<td style={{ fontWeight: "600", minWidth: "55px" }}></td>}

								<td style={{ fontWeight: "600", minWidth: "55px" }}></td>
								<td style={{ fontWeight: "600", minWidth: "155px" }}>М({data?.mCount}) + Ж({data?.wCount})
									{(data?.bCount) ? " + Б" + data?.bCount : ""} = {data?.mCount + data?.wCount + data?.bCount}</td>

								{(data?.showemail && data?.userType != "artist") &&
									<td style={{ fontWeight: "600", minWidth: "55px" }}></td>}
								{(data?.showemail && data?.userType != "artist") &&
									<td style={{ fontWeight: "600", minWidth: "55px" }}></td>}
								{(data?.showcomment) && <td style={{ fontWeight: "600", minWidth: "55px" }}></td>}

								{JSXMap(data?.tptYacheikiUslugi, (yacheika, idx) => {
									let summ = data?.mCountPlus[idx] + data?.wCountPlus[idx] + data?.bCountPlus[idx] + data?.mCountUsed[idx] + data?.wCountUsed[idx] + data?.bCountUsed[idx]
									let strRes = ""
									if (summ > 0) {
										let first = true

										if ((data?.mCountPlus[idx] + data?.mCountUsed[idx]) > 0) {
											strRes += "М(" + (data?.mCountPlus[idx] + data?.mCountUsed[idx]) + ")"
											first = false
										}
										if ((data?.wCountPlus[idx] + data?.wCountUsed[idx]) > 0) {
											if (!first) {
												strRes += " + "
											}
											strRes += "Ж(" + (data?.wCountPlus[idx] + data?.wCountUsed[idx]) + ")"
											first = false
										}
										if ((data?.bCountPlus[idx] + data?.bCountUsed[idx]) > 0) {
											if (!first) {
												strRes += " + "
											}
											strRes += "Б(" + (data?.bCountPlus[idx] + data?.bCountUsed[idx]) + ")"
											first = false
										}
										strRes += " = " + summ
									}
									return (<td key={idx} style={{ fontWeight: "600", minWidth: "155px" }}>
										{strRes}
									</td>)
								})}
							</tr>
							<tr style={{ backgroundColor: "#fbe5d6", overflowWrap: "anywhere", fontSize: "14px" }}>
								<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>
								<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>

								{(data?.showsum) && <td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>}
								{(data?.showpromo && data?.userType != "artist") &&
									<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>}

								<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>
								<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>
								{(data?.showemail && data?.userType != "artist") &&
									<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>}
								{(data?.showemail && data?.userType != "artist") &&
									<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>}
								{(data?.showcomment) && <td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>}

								{JSXMap(data?.tptYacheikiUslugi, (yacheika, idx) => {
									let summ = data?.mCountPlus[idx] + data?.wCountPlus[idx] + data?.bCountPlus[idx]
									let strRes = ""
									if (summ > 0) {
										let first = true

										if ((data?.mCountPlus[idx]) > 0) {
											strRes += "М(" + (data?.mCountPlus[idx]) + ")"
											first = false
										}
										if ((data?.wCountPlus[idx]) > 0) {
											if (!first) {
												strRes += " + "
											}
											strRes += "Ж(" + (data?.wCountPlus[idx]) + ")"
											first = false
										}
										if ((data?.bCountPlus[idx]) > 0) {
											if (!first) {
												strRes += " + "
											}
											strRes += "Б(" + (data?.bCountPlus[idx]) + ")"
											first = false
										}
										strRes += " = " + summ
									}
									return (<td key={idx} style={{ fontWeight: "600", minWidth: "55px" }}>
										{strRes}
									</td>)
								})}
							</tr>
							<tr style={{ backgroundColor: "#00b050", overflowWrap: "anywhere", fontSize: "14px" }}>
								<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>
								<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>

								{(data?.showsum) && <td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>}

								{(data?.showpromo && data?.userType != "artist") &&
									<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>}

								<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>
								<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>
								{(data?.showemail && data?.userType != "artist") &&
									<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>}
								{(data?.showemail && data?.userType != "artist") &&
									<td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>}
								{(data?.showcomment) && <td style={{ fontWeight: "600", minWidth: "55px", padding: "0" }}></td>}

								{JSXMap(data?.tptYacheikiUslugi, (yacheika, idx) => {
									let summ = data?.mCountUsed[idx] + data?.wCountUsed[idx] + data?.bCountUsed[idx]
									let strRes = ""
									if (summ > 0) {
										let first = true

										if ((data?.mCountUsed[idx]) > 0) {
											strRes += "М(" + (data?.mCountUsed[idx]) + ")"
											first = false
										}
										if ((data?.wCountUsed[idx]) > 0) {
											if (!first) {
												strRes += " + "
											}
											strRes += "Ж(" + (data?.wCountUsed[idx]) + ")"
											first = false
										}
										if ((data?.bCountUsed[idx]) > 0) {
											if (!first) {
												strRes += " + "
											}
											strRes += "Б(" + (data?.bCountUsed[idx]) + ")"
											first = false
										}
										strRes += " = " + summ
									}
									return (<td key={idx} style={{ fontWeight: "600", minWidth: "55px" }}>
										{strRes}
									</td>)
								})}
							</tr>
						</thead>
						<tbody style={{ fontSize: "14px" }}>
							{JSXMap(data?.tptPayments, (payment, idx) => {
								let komments = [];
								let strKomments = "";
								for (const key in payment?.paymentMap) {
									if (Object.prototype.hasOwnProperty.call(payment?.paymentMap, key)) {
										const element = payment?.paymentMap[key];
										for (let t = 0; t < element?.length; t++) {
											const item = element[t];
											let kom = item?.uchastik?.tovarVZakaze?.kommentarii?.trim()
											let exist = false;
											for (let k = 0; k < komments?.length; k++) {
												if (komments[k] == kom) {
													exist = true;
													break;
												}
											}
											if (!exist) {
												komments.push(kom);
												if (strKomments == "") {
													strKomments = kom
												} else {
													strKomments += ", " + kom
												}
											}
											
										}
										
									}
								}

								return (<tr key={idx}>
									<td style={{ padding: "0", textAlign: "center" }}>{(idx + 1)}</td>
									<td style={{ textAlign: "left" }}>{dayjs(payment?.lastPaymentDate).format("DD.MM.YYYY HH:mm")}</td>

									{(data?.showsum) && <td style={{ minWidth: "55px", textAlign: "right" }}>{toPrice(payment?.totalPaymentSumm)}</td>}

									{(data?.showpromo && data?.userType != "artist") &&
										<td style={{ minWidth: "55px", textAlign: "left" }}>{payment?.promoStr}</td>}

									<td style={{ textAlign: "left" }}>{payment?.buyerStr}</td>
									<td style={{ textAlign: "left", backgroundColor: "#ccffcc", fontWeight: "bold" }}>{payment?.name}</td>
									{(data?.showemail && data?.userType != "artist") &&
										<td style={{ textAlign: "left", backgroundColor: "#ccffcc", fontWeight: "bold" }}>{payment?.polzovatel?.email || ""}</td>}
									{(data?.showemail && data?.userType != "artist") &&
										<td style={{ textAlign: "left", backgroundColor: "#ccffcc", fontWeight: "bold" }}>{payment?.polzovatel?.phone || ""}</td>}
									{(data?.showcomment) && <td style={{ minWidth: "255px", padding: "0" }}>{strKomments}</td>}

									{JSXMap(data?.tptYacheikiUslugi, (yacheika, idx1) => {
										let val = ""
										let backgroundColor = "white"
										let uslList = payment?.paymentMap?.[yacheika.yacheikaUslugi.ID]
										if (uslList?.length) {
											for (let i = 0; i < uslList?.length; i++) {
												const usl = uslList[i];

												if (usl?.kategoriya && usl?.uslugaKlientu?.yacheikaUsluga?.nazvanie?.trim()?.toLowerCase() == "основное направление") {
													if ((i + 1) == uslList.length) {
														val += (usl?.kategoriya?.kategoriya?.kategoriyaUchastnikov?.nazvanie || "")
													} else {
														val += (usl?.kategoriya?.kategoriya?.kategoriyaUchastnikov?.nazvanie || "") + ", "
													}
												} else {
													if (isUsed(payment?.polzovatel, usl)) {
														backgroundColor = "#92d050"
														val += "V"
													} else {
														val += "+"
													}
												}
											}
										}
										return (<td key={"a" + idx1 + "|" + idx} style={{ textAlign: "left", fontWeight: "bold", backgroundColor: backgroundColor }}>
											{val}
										</td>)
									})}
								</tr>)
							})}
						</tbody>
					</table>
				</article>
			</div>}
		</div >);
}
